module.exports = __webpack_public_path__ + "img/character-auto-logistic-trash-slots.aebf22bd.png";